var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',{attrs:{"value":_vm.value,"inputOptions":{'placeholder': _vm.placeholder},"mode":"international"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }